export const ADDRESS_CHECKER_FORM_ID_BASE = '_address_checker_form'
export const ADDRESS_INPUT_ID_BASE = '_address_input'
export const ZIP_INPUT_ID_BASE = '_zip_input'
export const ADDRESS_CHECKER_SUBMIT_BUTTON_ID_BASE = '_address_checker_submit_button'
